export type EvidenceMode = "2d" | "3d";

export interface EvidenceGuidance {
  mode: EvidenceMode;
  source: string;
  instruction: string;
}

export const EVIDENCE_GUIDANCE: Record<string, EvidenceGuidance> = {
  // One dimension now, so `mode` is only where the participant lands: both surfaces are needed
  // and the instruction says so. What to look for lives in the dimension's own help; saying it
  // twice in adjacent boxes is what made the page wordy before.
  overall_quality: { mode: "2d", source: "2D 渲染 + 3D 操作 + 参考图", instruction: "两个面都要用：2D 渲染图对着参考图看外观，3D 里亲手拖过六个产物再判断关节与物理表现。静态图不能替代操作。" },
};

/** What the single v10 dimension asks for, as three scannable criteria.
 *  The manifest's own `question`/`help` are frozen inside the published build, so restructuring
 *  them there would move the manifest identity and retire every live session. Rendering the same
 *  three criteria from the frontend changes only what is on screen. When a protocol has more than
 *  one dimension there is no entry here and the manifest's question/help are shown as before. */
export interface DimensionCriterion {
  title: string;
  detail: string;
}
export const DIMENSION_CRITERIA: Record<string, DimensionCriterion[]> = {
  overall_quality: [
    { title: "视觉质量 · 2D 渲染", detail: "哪个更接近参考图与描述。" },
    { title: "关节结构 · 2D 与 3D", detail: "该动的部件是否切分正确，转轴与方向对不对。" },
    { title: "物理交互 · 3D", detail: "哪个用起来更像真实物体。" },
  ],
};
